document.addEventListener('DOMContentLoaded', function() {
  
  // Функция для добавления фильтра к ссылке на коллекцию
  function addFilterToCollectionLink(link) {
    const href = link.getAttribute('href');
    
    // Проверяем, что это ссылка на коллекцию и там еще нет параметров
    if (href && href.includes('/collections/') && !href.includes('?')) {
      // Получаем текст ссылки
      let linkText = link.textContent.trim();
      
      // Убираем лишние символы и пробелы
      linkText = linkText.replace(/→/g, '').trim();
      
      // Пропускаем пустые тексты
      if (!linkText) return;
      
      console.log('Название из ссылки:', linkText);
      
      // Формируем фильтр из названия
      const filterValue = encodeURIComponent(linkText).replace(/%20/g, '+');
      
      console.log('Значение фильтра:', filterValue);
      
      // Добавляем фильтр к URL
      const filterParam = 'filter.v.option.phone+model=' + filterValue;
      const newHref = href + '?' + filterParam;
      link.setAttribute('href', newHref);
      console.log('Новая ссылка:', newHref);
    }
  }
  
  // Обрабатываем карточки коллекций
  document.querySelectorAll('.collection-card-wrapper a.full-unstyled-link').forEach(function(link) {
    const href = link.getAttribute('href');
    
    if (href && href.includes('/collections/')) {
      // Для карточек ищем название в специальном элементе
      const titleElement = link.querySelector('.sw-base-text-color p');
      
      if (titleElement) {
        let collectionTitle = titleElement.textContent.trim();
        
        if (!collectionTitle) return;
        
        console.log('Название коллекции:', collectionTitle);
        
        const filterValue = encodeURIComponent(collectionTitle).replace(/%20/g, '+');
        
        console.log('Значение фильтра:', filterValue);
        
        if (filterValue && !href.includes('?')) {
          const filterParam = 'filter.v.option.phone+model=' + filterValue;
          const newHref = href + '?' + filterParam;
          link.setAttribute('href', newHref);
          console.log('Новая ссылка:', newHref);
        }
      }
    }
  });
  
  // Обрабатываем ссылки в десктопном меню
  document.querySelectorAll('.header__inline-menu a.header__menu-item').forEach(addFilterToCollectionLink);
  
  // Обрабатываем ссылки в мобильном меню
  document.querySelectorAll('.menu-drawer a.menu-drawer__menu-item').forEach(addFilterToCollectionLink);
  
});